import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

import { TakeActionDropdownData } from './TakeActionDropdownData';

export const takeActionDropdownDataPt: TakeActionDropdownData = {
  triggerText: 'Impactar',
  triggerHref: getMainVolopsSearchRoutePath({ lang: 'pt' }),
  search: {
    title: 'Busca',
    items: [
      {
        type: 'volop',
        icon: 'hand',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'pt' }),
      },
      {
        type: 'event',
        icon: 'star-calendar',
        title: 'Eventos',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'donations',
        icon: 'money',
        title: 'Doações',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
      {
        type: 'donations',
        icon: 'group',
        title: 'Petições',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['PETITION'] },
        }),
      },
      {
        type: 'loans',
        icon: 'loan',
        title: 'Empréstimos',
        href: getMainVolopsSearchRoutePath({
          lang: 'pt',
          filters: { type: 'VOLOP', actionType: ['LOAN'] },
        }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/announce-illustration.svg',
        title: 'Movimento Idealista',
        description:
          'Bem Vindo ao Movimento Idealista. Aqui você encontra formas de se conectar e pode conhecer o ecossistema idealista para transformação social.',
        href: '/pt/movimento',
      },
      {
        image: 'illustrations/article-illustration.svg',
        title: 'Blog Idealista',
        description:
          'Vamos transformar nossas comunidades? Quer trabalhar no terceiro setor? Recursos e Dicas para o Transformador Social.',
        href: '/pt/blog',
      },
    ],
  },
};
